import React from 'react';
import { Modal, useModal } from '../_components';
import { ImageForm } from './forms';

export function ImageModal({ item, prevModal, prevForm }) {
  return (
    <Modal
      id="imageFormModal"
      // backdrop
      title={item ? 'Edit Image' : 'New Image'}
      icon="far fa-image"
      size="md"
      open
    >
      <ImageForm item={item} prevModal={prevModal} prevForm={prevForm} />
    </Modal>
  );
}
